import {
    FETCH_CONTROLS_START,
    FETCH_CONTROLS_SUCCESS,
    FETCH_CONTROLS_ERROR,
    EDIT_CONTROL,
    EDIT_GENERATED_CONTROL,
    EDIT_SAVED_CONTROL,
    DISCARD_CONTROL,
    DISCARD_SAVED_CONTROL,
    ADD_RISK_TO_FETCHED,
    REMOVE_RISK_FROM_FETCHED,
    UPDATE_CONTROL_EVALUATION_FIELD,
    SET_SAVED_CONTROLS_START,
    SET_SAVED_CONTROLS_SUCCESS,
    SET_SAVED_CONTROLS_ERROR,
    FETCH_SAVED_CONTROL_EVALUATIONS_START,
    FETCH_SAVED_CONTROL_EVALUATIONS_SUCCESS,
    FETCH_SAVED_CONTROL_EVALUATIONS_ERROR,
    ADD_SAVED_CONTROL,
    SET_FETCHING_CONTROLS_STATUS,
    RESET_CONTROLS_STATE,
    REFRESH_CONTROLS_START,
    REFRESH_CONTROLS_SUCCESS,
    REFRESH_CONTROLS_ERROR,
    FETCH_ACTIONPLAN_START,
    FETCH_ACTIONPLAN_SUCCESS,
    FETCH_ACTIONPLAN_ERROR,
    EDIT_GENERATED_ACTIONPLAN_ROW,
    EDIT_SAVED_ACTIONPLAN_ROW

} from '../actions/controlActions.js';

// Import RTK thunks for extraReducers-style handling
import { persistControlName } from '../slices/risksSlice.js'; 

const initialState = {
  controls: {},              // Generated controls by riskId
  controlsLoading: {},
  fetchingControlsStatus: {},
  savedControls: {},         // Saved controls by riskId - each control has assessmentUuid for filtering
  actionPlan:[],
  controlEvaluations: {},
  discardedControls: {},
  savedControlEvaluations: {},
  fetchedRisks: [],
  loading: false,
  error: null
};

/**
 * Control Schema (with Policy Evidence):
 * {
 *   controlId: string,
 *   name: string,
 *   description: string,
 *   riskIds: string[],
 *   status: 'generated' | 'saved',
 *   source: 'AI_Generated' | 'AI_with_Policy_Match' | 'Policy_RAG',
 *   policyEvidence: [                     // NEW: Directive-level policy matches (optional)
 *     {
 *       directiveName: string,            // e.g., "Balanced Sampling Techniques"
 *       sectionNumber: string,            // e.g., "5.1"
 *       sectionTitle: string,             // e.g., "Data Collection & Labeling"
 *       controlType: string,              // e.g., "technical" | "procedural"
 *       regulatoryReference: string,      // e.g., "GDPR Art. 22, ISO 42001"
 *       text: string,                     // Full directive text
 *       file_name: string,                // Source policy file
 *       policyType: string,               // 'governance' | 'security' | 'ai-control'
 *       sub_category: string,             // Policy sub-category
 *       similarity: number                // Match score (0-1)
 *     }
 *   ]
 * }
 */


const controlReducer = (state = initialState, action) => {
    switch (action.type) {

      case RESET_CONTROLS_STATE:
      return initialState;
      
      case FETCH_CONTROLS_START:
        return {
          ...state,
          loading: true,
          error: null
        };


        case FETCH_CONTROLS_SUCCESS:

        const newFetchingStatus = { ...state.fetchingControlsStatus };
        console.log ('payload in fetch control success', action.payload)
        Object.keys(action.payload).forEach(riskId => {
            newFetchingStatus[riskId] = false;
        });
          return {
              ...state,
              controls: {
                  ...state.controls,
                  ...action.payload
              },
              fetchingControlsStatus: newFetchingStatus,
              loading: false
          };
    
          case FETCH_CONTROLS_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };


            
              case REFRESH_CONTROLS_START:
              return {
                  ...state,
                  fetchingControlsStatus: {
                      ...state.fetchingControlsStatus,
                      [action.payload.riskId]: true,
                  },
                  loading: true,
                  error: null
              };
              case REFRESH_CONTROLS_SUCCESS:{
                const newFetchingStatus = { ...state.fetchingControlsStatus };
                Object.keys(action.payload).forEach(riskId => {
                    newFetchingStatus[riskId] = false;
                });
                return {
                    ...state,
                    controls: {
                        ...state.controls,
                        ...action.payload
                    },
                    fetchingControlsStatus: newFetchingStatus,
                    loading: false
                };
              }

              case REFRESH_CONTROLS_ERROR:
                return {
                    ...state,
                    error: action.payload,
                    fetchingControlsStatus: {
                        ...state.fetchingControlsStatus,
                        [action.payload.riskId]: false,
                    },
                    loading: false
                };
 
   
      case EDIT_CONTROL: {
        const { riskId, index, controlData } = action.payload;

        console.log('editing control from report', controlData )
      
        const updatedControls = {
          ...state.controls,
          [riskId]: state.controls[riskId].map((control, idx) =>
            idx === index ? { ...control, ...controlData } : control
          ),
        };
      
        return {
          ...state,
          controls: updatedControls,
        };
      }

      case EDIT_GENERATED_CONTROL: {
        const { riskId, controlId, newName } = action.payload;
        const existing = state.controls[riskId] || [];
        // Find the control to update
        const updated = existing.map(ctrl => {
          if (ctrl.controlId === controlId) {
            return { ...ctrl, name: newName };
          }
          return ctrl;
        });
        return {
          ...state,
          controls: {
            ...state.controls,
            [riskId]: updated,
          },
        };
      }
      case EDIT_SAVED_CONTROL: {
        const { riskId, controlId, newName } = action.payload;
        const existingSaved = state.savedControls[riskId] || [];
        const updatedSaved = existingSaved.map(ctrl =>
          ctrl.controlId === controlId
            ? { ...ctrl, name: newName }
            : ctrl
        );
        return {
          ...state,
          savedControls: {
            ...state.savedControls,
            [riskId]: updatedSaved
          }
        };
      }
      case EDIT_GENERATED_ACTIONPLAN_ROW: {
        const { controlId, newName } = action.payload;
        return {
          ...state,
          actionPlan: state.actionPlan.map(c =>
            c.controlId === controlId ? { ...c, name: newName } : c
          ),
        };
      }
      
      case EDIT_SAVED_ACTIONPLAN_ROW: {
        const { controlId, newName } = action.payload;
      
        // 1) update actionPlan
        const updatedPlan = state.actionPlan.map(c =>
          c.controlId === controlId ? { ...c, name: newName } : c
        );
      
        // 2) update every risk bucket where this control lives
        const updatedSavedControls = { ...state.savedControls };
        Object.keys(updatedSavedControls).forEach(rid => {
          updatedSavedControls[rid] = updatedSavedControls[rid].map(c =>
            c.controlId === controlId ? { ...c, name: newName } : c
          );
        });
      
        return {
          ...state,
          actionPlan: updatedPlan,
          savedControls: updatedSavedControls,
        };
      }
      case DISCARD_CONTROL: {
        const { controlId, riskId } = action.payload;
  
        if (state.discardedControls[riskId]?.some(c => c.controlId === controlId)) {
          return state;
        }
        const updatedDiscarded = {
          ...state.discardedControls,
          [riskId]: [
            ...(state.discardedControls[riskId] || []),
            action.payload
          ]
        };
       
        const updatedPerRisk = state.controls[riskId]
          ? state.controls[riskId].filter(c => c.controlId !== controlId)
          : state.controls[riskId];
     
        
       const updatedPlan = state.actionPlan.filter(c => c.controlId !== controlId);
     
        return {
          ...state,
          discardedControls: updatedDiscarded,
          controls: {
            ...state.controls,
            [riskId]: updatedPerRisk
          },
         actionPlan: updatedPlan
        };
      }
          case ADD_RISK_TO_FETCHED:
            return {
              ...state,
              fetchedRisks: [...state.fetchedRisks, action.payload]
            };

          case REMOVE_RISK_FROM_FETCHED:
            const refreshedRisks = state.fetchedRisks.filter(risk => risk !== action.payload);
            return {
              ...state,
              fetchedRisks: refreshedRisks
            };

    

case UPDATE_CONTROL_EVALUATION_FIELD: {
  const { riskId, controlId, fieldName, value } = action.payload;

  // Retrieve the current evaluations for the controlId, defaulting to an empty array if not present
  const currentEvaluations = state.savedControlEvaluations[riskId]?.[controlId] || [];

  // Assuming we're updating the first evaluation in the array
  const updatedEvaluation = {
    // Spread the existing fields from the first evaluation
    ...(currentEvaluations[0] || {}),
    // Update the specified field, converting the fieldName to snake_case
    [fieldName.replace(/([A-Z])/g, letter => `_${letter.toLowerCase()}`)]: value,
  };

  

  return {
    ...state,
    savedControlEvaluations: {
      ...state.savedControlEvaluations,
      [riskId]: {
        ...state.savedControlEvaluations[riskId],
        // Update the array of evaluations for the controlId, with the updated evaluation at the first position
        [controlId]: [updatedEvaluation, ...currentEvaluations.slice(1)],
      },
    },
  };
}

 

case SET_SAVED_CONTROLS_START:
  return {
    ...state,
    loading: true
  };




  case SET_SAVED_CONTROLS_SUCCESS: {
    const assessmentUuid = action.meta?.assessmentUuid;
    const modelId = action.meta?.modelId;

    console.log('[controlReducer] SET_SAVED_CONTROLS_SUCCESS', {
      assessmentUuid,
      modelId,
      payloadRiskCount: Object.keys(action.payload).length,
      payloadControlCount: Object.values(action.payload).flat().length
    });

    /* Merge payload into savedControls, tagging each control with assessmentUuid */
    const updatedSavedControls = { ...state.savedControls };
    Object.entries(action.payload).forEach(([riskId, controls]) => {
      const list = updatedSavedControls[riskId] || [];
      controls.forEach(control => {
        const ctrl = {
          ...control,
          modelId: control.modelId || modelId,
          assessmentUuid: assessmentUuid // Tag for filtering
        };
        const idx = list.findIndex(c => c.controlId === ctrl.controlId);
        idx > -1 ? (list[idx] = ctrl) : list.push(ctrl);
      });
      updatedSavedControls[riskId] = list;
    });

    /* Flatten and dedupe saved controls into actionPlan rows */
    const seen = {};
    Object.values(updatedSavedControls).flat().forEach(c => {
      const ctrl = {
        ...c,
        status: 'saved',
        riskIds: Array.isArray(c.riskIds) ? [...c.riskIds] : [c.riskId],
      };
      if (!seen[ctrl.controlId]) {
        seen[ctrl.controlId] = ctrl;
      } else {
        seen[ctrl.controlId].riskIds = Array.from(
          new Set([...seen[ctrl.controlId].riskIds, ...ctrl.riskIds])
        );
      }
    });
    const flatSaved = Object.values(seen);

    return {
      ...state,
      savedControls: updatedSavedControls,
      actionPlan: [...state.actionPlan.filter(c => c.status === 'generated'), ...flatSaved],
      loading: false
    };
  }


case SET_SAVED_CONTROLS_ERROR:
  return {
    ...state,
    error: action.payload,
    loading: false
  };
  case FETCH_SAVED_CONTROL_EVALUATIONS_START:
  return {
    ...state,
    loading: true,
    error: null,
  };

  case FETCH_SAVED_CONTROL_EVALUATIONS_SUCCESS:
    return {
      ...state,
      savedControlEvaluations: {
        ...state.savedControlEvaluations,
        ...action.payload, // Assumes payload is structured with risk_id as top-level keys
      },
      loading: false,
    };
  

case FETCH_SAVED_CONTROL_EVALUATIONS_ERROR:
  return {
    ...state,
    loading: false,
    error: action.payload,
  };



case ADD_SAVED_CONTROL: {
  const ctrl = {
     ...action.payload,
      status:'saved', 
       riskIds: Array.isArray(action.payload.riskIds)
         ? action.payload.riskIds
        : [action.payload.riskId]
    }; 
  /* 3-a  update actionPlan list */
  const newActionPlan = [
       ...state.actionPlan.filter(c => c.controlId !== ctrl.controlId), // drop any generated copy
       ctrl                                                     
     ];
    

  /* 3-b  merge into savedControls per risk */
  const newSaved = { ...state.savedControls };
  ctrl.riskIds.forEach((rid) => {
    const list = newSaved[rid] || [];
    const i = list.findIndex(c => c.controlId === ctrl.controlId);
    i >= 0 ? (list[i] = ctrl) : list.push(ctrl);
    newSaved[rid] = list;
  });

  return { ...state, savedControls: newSaved, actionPlan: newActionPlan };
}

// case 'DISCARD_SAVED_CONTROL': {
//   const { controlId, riskId, ...ctrl } = action.payload;
//   // 1) Remove the control from savedControls for this risk
//   const updatedSavedList = (state.savedControls[riskId] || []).filter(
//     c => c.controlId !== controlId
//   );
//   // 2) Remove the control's evaluation entries for this risk
//   const existingEvalsForRisk = state.savedControlEvaluations[riskId] || {};
//   const { [controlId]: _, ...remainingEvalsForRisk } = existingEvalsForRisk;
//   // 3) Remove the control from the actionPlan list
//   const updatedActionPlan = state.actionPlan.filter(c => c.controlId !== controlId);

//   return {
//     ...state,
//     savedControls: {
//       ...state.savedControls,
//       [riskId]: updatedSavedList,
//     },
//     savedControlEvaluations: {
//       ...state.savedControlEvaluations,
//       [riskId]: remainingEvalsForRisk,
//     },
//     actionPlan: updatedActionPlan,
//   };
// }

case DISCARD_SAVED_CONTROL: {
 
    const { controlId, riskId, ...ctrl } = action.payload;
  
     /* 1️⃣  Remove from savedControls bucket */
     const updatedSavedList = (state.savedControls[riskId] || []).filter(
       c => c.controlId !== controlId
     );
  
     /* 2️⃣  Strip any evaluations tied to this control */
     const { [controlId]: _omit, ...remainingEvals } =
       state.savedControlEvaluations[riskId] || {};
  

   
    /* 3️⃣  Remove from flat actionPlan */
    const updatedActionPlan = state.actionPlan.filter(c => c.controlId !== controlId);
  
    /* 4️⃣  ADD to discardedControls so badge/modal update */
    const updatedDiscarded = {
      ...state.discardedControls,
      [riskId]: [
        ...(state.discardedControls[riskId] || []),
        { ...ctrl, controlId }
      ]
    };
  
     return {
       ...state,
       savedControls: { ...state.savedControls, [riskId]: updatedSavedList },
       savedControlEvaluations: {
         ...state.savedControlEvaluations,
         [riskId]: remainingEvals
       },
     discardedControls: updatedDiscarded,
       actionPlan: updatedActionPlan
     };
   }



case SET_FETCHING_CONTROLS_STATUS: {
  const { riskId, isFetching } = action.payload;
  return {
    ...state,
    fetchingControlsStatus: {
      ...state.fetchingControlsStatus,
      [riskId]: isFetching,
    },
  };
}

    case FETCH_ACTIONPLAN_START:
      return { ...state, loading:true, error:null };
      case FETCH_ACTIONPLAN_SUCCESS:
        return {
          ...state,
          actionPlan: [
            ...state.actionPlan.filter(c => c.status === 'saved'),
            ...action.payload                // all 'generated'
          ],
          loading:false
        };
   case FETCH_ACTIONPLAN_ERROR:
      return { ...state, error:action.payload, loading:false };

    // Handle RTK thunk: persistControlName.fulfilled
    case persistControlName.fulfilled.type: {
      const { controlId, controlName, riskIds } = action.payload;

      // Update in savedControls for each riskId
      const updatedSavedControls = { ...state.savedControls };
      riskIds.forEach(riskId => {
        const controls = updatedSavedControls[riskId] || [];
        const index = controls.findIndex(c => c.controlId === controlId);
        if (index >= 0) {
          controls[index] = { ...controls[index], name: controlName };
          updatedSavedControls[riskId] = controls;
        }
      });

      // Update in actionPlan (flattened view)
      const updatedActionPlan = state.actionPlan.map(c =>
        c.controlId === controlId ? { ...c, name: controlName } : c
      );

      return {
        ...state,
        savedControls: updatedSavedControls,
        actionPlan: updatedActionPlan
      };
    }

    default:
      return state;
  }
};



export default controlReducer;
